module.exports = __webpack_public_path__ + "static/media/failed.fbf1a43c.svg";